var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKorean(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9987 11.5C22.9987 17.8519 17.8506 23 11.4987 23C5.14681 23 0 17.8506 0 11.5C0 5.14943 5.14943 0 11.5 0C17.8506 0 23 5.14812 23 11.5H22.9987Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4422 11.9401C9.40731 12.664 10.7763 12.4673 11.5001 11.5008C12.224 10.5357 13.5929 10.339 14.5581 11.0629C15.5245 11.7867 15.7212 13.1557 14.9973 14.1221C16.445 12.1906 16.0516 9.4513 14.1201 8.00495C12.1886 6.55729 9.45058 6.95067 8.00292 8.8822C7.27909 9.84731 7.47578 11.2176 8.4422 11.9414V11.9401Z",
    fill: "#E60012"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5591 11.0628C13.594 10.339 12.2237 10.5357 11.5012 11.5008C10.7773 12.4672 9.40836 12.6626 8.44325 11.9401C7.47684 11.2163 7.28014 9.84728 8.00397 8.88086C6.55631 10.8124 6.9497 13.5517 8.88123 14.998C10.8128 16.4457 13.552 16.0523 14.9984 14.1208C15.7222 13.1543 15.5255 11.7854 14.5591 11.0615V11.0628Z",
    fill: "#0B318F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83434 13.3155L4.22852 13.7188L6.6503 17.3569L7.25612 16.9537L4.83434 13.3155Z",
    fill: "#231815"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.01402 14.5254L2.4082 14.9287L4.82999 18.5669L5.43581 18.1636L3.01402 14.5254Z",
    fill: "#231815"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.92418 13.921L3.31836 14.3242L4.42862 15.9921L5.03444 15.5889L3.92418 13.921Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23661 15.8886L4.63086 16.292L5.74068 17.9586L6.34643 17.5552L5.23661 15.8886Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2611 5.03828L16.6543 5.44238L19.076 9.07906L19.6828 8.67496L17.2611 5.03828Z",
    fill: "#231815"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1735 4.43421L17.5664 4.83789L18.6751 6.50529L19.2822 6.10162L18.1735 4.43421Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4827 6.4062L18.877 6.80957L19.9868 8.4762L20.5925 8.07283L19.4827 6.4062Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3529 5.6456L15.7461 6.0498L16.8562 7.71624L17.463 7.31203L16.3529 5.6456Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6656 7.6177L17.0586 8.02148L18.1675 9.68869L18.7746 9.28491L17.6656 7.6177Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82252 4.44338L2.40527 8.08301L3.01152 8.48564L5.42877 4.84601L4.82252 4.44338Z",
    fill: "#231815"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73341 5.0458L3.31543 8.68652L3.92276 9.08988L6.34074 5.44916L5.73341 5.0458Z",
    fill: "#231815"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64293 5.64889L4.22559 9.29004L4.8319 9.69257L7.24924 6.05142L6.64293 5.64889Z",
    fill: "#231815"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7728 15.8789L16.665 17.5469L17.2713 17.9495L18.3791 16.2815L17.7728 15.8789Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0827 13.9064L17.9746 15.5742L18.5808 15.977L19.6889 14.3092L19.0827 13.9064Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8575 15.2859L15.75 16.9541L16.3563 17.3566L17.4638 15.6885L16.8575 15.2859Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1665 13.3109L17.0596 14.9795L17.666 15.3818L18.7729 13.7132L18.1665 13.3109Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6781 16.4941L17.5703 18.1621L18.1766 18.5647L19.2843 16.8968L18.6781 16.4941Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9891 14.5212L18.8809 16.1904L19.4872 16.593L20.5954 14.9237L19.9891 14.5212Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKorean);
export default __webpack_public_path__ + "static/media/korean.4f0b589144ee51426b76aa30ba286fad.svg";
export { ForwardRef as ReactComponent };